import { csosUpmApi } from '.';
import { ResponseCSOSHeaders } from '../interfaces/icam';

export const feature = (hR: ResponseCSOSHeaders) =>
  csosUpmApi(hR).post('/v1/api/upm/feature-toggle', {
    environment: import.meta.env.VITE_ENV || 'dev',
    features: [
      {
        featureName: 'sailpoint',
        versionNum: '2.1.1',
      },
      {
        featureName: 'revoke',
        versionNum: '2.1.1',
      },
      {
        featureName: 'disable-doc-upload',
        versionNum: '2.1.1',
      },
      {
        featureName: 'employment-verification',
        versionNum: '1.0.0',
      },
      {
        featureName: 'id-proof-re-enroll',
        versionNum: '1.0.0',
      },
    ],
  });
